import React from 'react';
import { formatDate } from '../utils/dateUtils';
import { padCountdown } from '../utils/countdown';

const units = [
  ['days', 'Tage', 3],
  ['hours', 'Stunden', 2],
  ['minutes', 'Minuten', 2],
  ['seconds', 'Sekunden', 2]
];

function SummerCountdown({ countdown, target, summerIsActive }) {
  if (!target) {
    return (
      <section className="countdown-card">
        <p className="section-kicker">Sommerglück</p>
        <h2>Der große Sommerferien-Countdown</h2>
        <p>Neue offizielle Ferientermine werden hier ergänzt, sobald sie vorliegen.</p>
      </section>
    );
  }

  const motivation = summerIsActive
    ? 'Heute genießt du Sommerferien – und die nächste Sommerfreude wächst bereits!'
    : countdown.days <= 30
      ? 'Der Sommer ist zum Greifen nah – Vorfreude pur!'
      : 'Jede Sekunde zählt Richtung Sommerglück!';

  return (
    <section className="countdown-card" aria-labelledby="countdown-title">
      <p className="section-kicker">Sommerglück im Blick</p>
      <h2 id="countdown-title">Der große Sommerferien-Countdown</h2>

      <div className="countdown-grid" aria-live="off">
        {units.map(([key, label, size]) => (
          <div className="countdown-unit" key={key}>
            <span>{padCountdown(countdown[key], size)}</span>
            <small>{label}</small>
          </div>
        ))}
      </div>

      <p className="countdown-target">
        Bis zum Start am {formatDate(target.startDate)} um 0:00 Uhr
      </p>
      <p className="countdown-motivation">{motivation}</p>
    </section>
  );
}

export default SummerCountdown;